define.alias("shared/components/shared/publish/switcher/index", "media/components/shared/publish/switcher/index");